import config from 'config';

export const colors = {
  '--primary-medium': {
    default: config.primary_medium_color,
    accessible: '#1B8384',
  },
  '--primary-light': {
    default: '#28BBBD',
    accessible: '#14A5A7',
  },
  '--primary-hard': {
    default: '#0E898B',
    accessible: '#075556',
  },

  '--red-light': {
    default: '#FC6A82',
    accessible: '#EB6363',
  },
  '--red-medium': {
    default: '#E63C3C',
    accessible: '#C81515',
  },
  '--red-hard': {
    default: '#C81515',
    accessible: '#A50000',
  },

  '--green-light': {
    default: '#16D722',
    accessible: '#43A047',
  },
  '--green-medium': {
    default: '#28B831',
    accessible: '#2E7D32',
  },
  '--green-hard': {
    default: '#24972B',
    accessible: '#08560C',
  },

  '--scrollbar-track-color': {
    default: '#ededed',
    accessible: '#ECECEC',
  },
  '--scrollbar-thumb-color': {
    default: '#dddddd',
    accessible: '#616161',
  },
};

export function switchColorsByAccessibilityOption(isAccessbilityTurnedOn) {
  const isAccessibilityOn = isAccessbilityTurnedOn !== undefined ? isAccessbilityTurnedOn : localStorage.getItem('ACCESSIBILITY_TURNED_ON') === 'true';

  if (isAccessibilityOn) {
    document.body.classList.add('accessibilityColorsEnabled');
  } else {
    document.body.classList.remove('accessibilityColorsEnabled');
  }

  Object.entries(colors).forEach(([colorVar, value]) => {
    document.documentElement.style.setProperty(colorVar, isAccessibilityOn ? value.accessible : value.default);
  });
}

